var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlastDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 215,
    height: 215,
    viewBox: "0 0 215 215",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M161 106.4L190.3 91.8001L200.4 60.8001L180.2 46.1001H45.7L14.6 69.2001H172.7L164.3 95.2001H100.9L94.8 114.2H158.2L140.4 168.9L170.1 154.2L180.7 121.4L160.8 106.8L161 106.4Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3 145.4L77.6 88.4002L57.3 73.2002L26.8 168.9H140.4L148 145.4H59.3Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlastDark);
export default __webpack_public_path__ + "static/media/blast_dark.c85a0d730c7b164d225d8b99a101f04a.svg";
export { ForwardRef as ReactComponent };